const SCROLL_LOCK_CLASS = 'mahaagx-scroll-locked';

let lockCount = 0;
let prevHtmlOverflow: string | null = null;
let prevBodyOverflow: string | null = null;

/**
 * Prevents background page scroll while overlays (modals, panels) are open.
 * Ref-counted so nested modals restore scroll only when the last one closes.
 */
export function lockBodyScroll(): void {
  if (typeof document === 'undefined') return;

  if (lockCount === 0) {
    prevHtmlOverflow = document.documentElement.style.overflow || null;
    prevBodyOverflow = document.body.style.overflow || null;
    document.documentElement.classList.add(SCROLL_LOCK_CLASS);
    document.body.classList.add(SCROLL_LOCK_CLASS);
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
  }

  lockCount++;
}

export function unlockBodyScroll(): void {
  if (typeof document === 'undefined' || lockCount === 0) return;

  lockCount = Math.max(0, lockCount - 1);
  if (lockCount !== 0) return;

  document.documentElement.classList.remove(SCROLL_LOCK_CLASS);
  document.body.classList.remove(SCROLL_LOCK_CLASS);
  document.documentElement.style.overflow = prevHtmlOverflow ?? '';
  document.body.style.overflow = prevBodyOverflow ?? '';
  prevHtmlOverflow = null;
  prevBodyOverflow = null;
}
